// src/components/operationCenter/widgets/token/valuation/TwMcTvlHistoryWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import McTvlHistoryChart from "@/components/tokenPage/valuation/McTvlHistoryChart";

const TwMcTvlHistoryWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["fundamentals"]}>
        <McTvlHistoryChart />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwMcTvlHistoryWidget;
